export const SELECTED_OBJECT = "SELECTED_OBJECT";

export function selectedObjectUuid(name, id) {
  return {
    type: SELECTED_OBJECT,
    selectedObject: name,
    id
  };
}
